/* Application environment
========================================================================== */

/* eslint-disable no-unused-vars */
/* eslint-disable no-native-reassign */
/**
 * Set up environment globals.
 */
const template = {
	component: {},
	util: {}
};

/**
 * Define jQuery in noConflict mode.
 */

/* eslint-disable no-global-assign */
$ = jQuery.noConflict();
/* eslint-enable no-global-assign */
